import { jsx as n, jsxs as l, Fragment as _ } from "react/jsx-runtime";
import { useTranslation as m } from "react-i18next";
import u from "classnames";
import h from "../Modal/index.js";
const f = "forma-ui__remove-modal__content", w = "forma-ui__remove-modal__withTitle", r = {
  content: f,
  withTitle: w
}, T = ({ open: c, onClose: a, control: d, onRemove: s, title: e, itemName: t, message: o }) => {
  const { t: i } = m();
  return /* @__PURE__ */ n(
    h,
    {
      size: "small",
      open: c,
      onClose: a,
      control: d,
      title: e,
      buttons: [
        {
          children: i("uikit:delete"),
          viewStyle: "danger",
          onClick: s
        },
        {
          children: i("uikit:cancel"),
          viewStyle: "tertiary"
        }
      ],
      children: /* @__PURE__ */ l("div", { className: u(r.content, e && r.withTitle), children: [
        o && o,
        t && /* @__PURE__ */ l(_, { children: [
          i("uikit:do_yo_want_delete"),
          " “",
          t,
          "”?"
        ] }),
        (o || t) && /* @__PURE__ */ n("br", {}),
        (o || t) && /* @__PURE__ */ n("br", {}),
        i("uikit:cancellation_notification")
      ] })
    }
  );
};
export {
  T as default
};
